module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.3a9ee10.ttf";